export const Option: { [locale: string]: string[] } = {
    eu: [
        'Austria',
        'Belgium',
        'Bulgaria',
        'Croatia',
        'Denmark',
        'Estonia',
        'Finland',
        'France',
        'Germany',
        'Greece',
        'Hungary',
        'Italy',
        'Latvia',
        'Luxembourg',
        'Netherlands',
        'Portugal',
        'Romania',
        'Slovakia',
        'Slovenia',
        'Spain',
        'Sweden',
        'Ireland',
        'Czechia',
        'Poland',
        'Lithuania',
    ],
    uk: ['United Kindom', 'Ireland', 'Jersey'],
    de: [
        'Belgien',
        'Bulgarien',
        'Dänemark',
        'Deutschland',
        'Estland',
        'Finnland',
        'Frankreich',
        'Griechenland',
        'Irland',
        'Italien',
        'Kroatien',
        'Lettland',
        'Litauen',
        'Luxemburg',
        'Niederlande',
        'Österreich',
        'Pole',
        'Portugal',
        'Rumänien',
        'Schweden',
        'Slowakei',
        'Slowenien',
        'Spanien',
        'Tschechien',
        'Ungarn',
    ],
    it: [
        'Austria',
        'Belgio',
        'Bulgaria',
        'Croazia',
        'Danimarca',
        'Estonia',
        'Finlandia',
        'Francia',
        'Germania',
        'Grecia',
        'Ungheria',
        'Italia',
        'Lettonia',
        'Lussemburgo',
        'Paesi Bassi',
        'Portogallo',
        'Romania',
        'Slovacchia',
        'Slovenia',
        'Spagna',
        'Svezia',
        'Irlanda',
        'Repubblica Ceca',
        'Polonia',
        'Lituania',
    ],
    es: [
        'Austria',
        'Bélgica',
        'Bulgaria',
        'Croacia',
        'Dinamarca',
        'Estonia',
        'Finlandia',
        'Francia',
        'Alemania',
        'Grecia',
        'Hungría',
        'Italia',
        'Letonia',
        'Luxemburgo',
        'Países Bajos',
        'Portugal',
        'Rumanía',
        'Eslovaquia',
        'Eslovenia',
        'España',
        'Suecia',
        'Irlanda',
        'Chequia',
        'Polonia',
        'Lituania',
    ],
    fr: [
        'Autriche',
        'Belgique',
        'Bulgarie',
        'Croatie',
        'Danemark',
        'Estonie',
        'Finlande',
        'France',
        'Allemagne',
        'Grèce',
        'Hongrie',
        'Italie',
        'Lettonie',
        'Luxembourg',
        'Pays-Bas',
        'Portugal',
        'Roumanie',
        'Slovaquie',
        'Slovénie',
        'Espagne',
        'Suède',
        'Irlande',
        'Tchéquie',
        'Pologne',
        'Lituanie',
    ],
};
